import { useState, useEffect } from 'react';
import {
  OutlinedInput,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import { TableContainer } from '@mui/material';
import { ReactComponent as DeleteIcon } from '../../../assets/ICONS/ic_round-delete-outline.svg';
import { useHistory } from 'react-router-dom';
import { config } from './config';
import { ERRORS } from '../../../utils/constants';
import { handleError } from '../../../utils/config';
import DeleteModal from '../../../components/Modals/DeleteModal/DeleteModal';
import { useDispatch } from 'react-redux';
import { userActions } from '../../../store/userSlice';
import TitleHeader from '../../../components/MasterComponent/TitleHeader/TitleHeader';
import { subAdminService } from '../../../services';
import './SubAdmins.css';

const SubAdmins: React.FC = () => {
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [subAdminDetails, setSubAdminDetails] = useState([]);
  const [networkError, setNetworkError] = useState('');
  const [search, setSearch] = useState('');
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [clickedData, setClickedData] = useState<any>();

  const dispatch = useDispatch();
  const onCloseDeleteModal = () => setDeleteModal(false);

  const handleSearchChange = (e: any) => {
    setSearch(e.target.value);
  };

  const fetchAllSubAdminsDetails = async () => {
    try {
      setLoader(true);
      const rows = await subAdminService.getALLSubAdminDetails();
      if (rows) {
        setSubAdminDetails(rows.subadmins);
      }
      setLoader(false);
    } catch (e: any) {
      setNetworkError(e === ERRORS.NETWORK_ERROR ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    } finally {
      setLoader(false);
    }
  };

  const deleteUser = async () => {
    try {
      const res = await config.deleteSubAdmin({
        userIds: [clickedData.id],
      });
      if (res?.message) {
        setSubAdminDetails((preValue: any) =>
          preValue.filter((subAdmin: any) => subAdmin.Id !== clickedData.id)
        );

        dispatch(
          userActions.replaceUserState({
            successMessage: res.message,
          })
        );
      }
    } catch (e: any) {
      setNetworkError(e === ERRORS.NETWORK_ERROR ? e : '');
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    } finally {
      setDeleteModal(false);
    }
  };

  const returnSearchResult = (data: any) => {
    const searchTerm = search?.toLowerCase().trim();
    if (!searchTerm) return data;

    const filtered = data?.filter((item: any) => {
      const fullName = `${item.FirstName ?? ''} ${
        item.LastName ?? ''
      }`.toLowerCase();
      const email = item.EmailAddress?.toLowerCase() || '';
      const contact = item.ContactNo?.toLowerCase() || '';
      const companies = Array.isArray(item.assignedCompanies)
        ? item.assignedCompanies.join(', ').toLowerCase()
        : '';

      return (
        fullName.includes(searchTerm) ||
        email.includes(searchTerm) ||
        contact.includes(searchTerm) ||
        companies.includes(searchTerm)
      );
    });

    return filtered;
  };

  useEffect(() => {
    fetchAllSubAdminsDetails();
  }, []);

  return (
    <>
      <div className="organizationDetails">
        <div className="OrgDetails-uppterStrip">
          <TitleHeader
            extraContent={
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}
              >
                <div className="OrgDetails-us-searchBar">
                  <OutlinedInput
                    id="email"
                    name="EmailAddress"
                    className="outlineInputArea bgcolor"
                    type="email"
                    autoComplete="off"
                    value={search ? search : ''}
                    onChange={handleSearchChange}
                    placeholder="Search..."
                    endAdornment={
                      <InputAdornment position="end">
                        <SearchOutlinedIcon />
                      </InputAdornment>
                    }
                  />
                </div>
              </div>
            }
          >
            All SubAdmins
          </TitleHeader>
        </div>
        <TableContainer
          sx={{ maxHeight: '74vh', overflowY: 'auto' }}
          className="accContainer"
        >
          <Table
            className="table adminTable OrgTable"
            size="small"
            aria-label="a dense table"
            stickyHeader
          >
            <TableHead className="admintableHead">
              <TableRow>
                <TableCell
                  className="adminTableheading"
                  align="right"
                  width="8%"
                >
                  S.No.
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Name
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Email
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Contact No.
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Organizations
                </TableCell>
                <TableCell className="adminTableheading" width={'30%'}>
                  Features
                </TableCell>
                <TableCell className="adminTableheading" width={'20%'}>
                  Status
                </TableCell>
                <TableCell className="adminTableheading" width={'20%'}>
                  Account Verified
                </TableCell>
                <TableCell className="adminTableheading" width={'25%'}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loader ? (
                <TableRow>
                  <TableCell
                    colSpan={11}
                    align="center"
                    className="loadingSection"
                  >
                    Loading...
                  </TableCell>
                </TableRow>
              ) : subAdminDetails?.length &&
                search &&
                !returnSearchResult(subAdminDetails).length ? (
                <TableRow>
                  <TableCell
                    colSpan={11}
                    align="center"
                    className="loadingSection"
                  >
                    No Searched Records
                  </TableCell>
                </TableRow>
              ) : subAdminDetails?.length ||
                returnSearchResult(subAdminDetails).length ? (
                returnSearchResult(subAdminDetails).map(
                  (subAdmin: any, i: number) => (
                    <TableRow
                      key={i}
                      className={i % 2 === 0 ? 'oddRow' : 'evenRow'}
                    >
                      <TableCell>{i + 1}</TableCell>
                      <TableCell>
                        <span>
                          {subAdmin.FirstName + ' ' + subAdmin.LastName}
                        </span>
                      </TableCell>
                      <TableCell>
                        <span>{subAdmin.EmailAddress}</span>
                      </TableCell>
                      <TableCell>
                        <span>{subAdmin.ContactNo}</span>
                      </TableCell>
                      <TableCell className="table-cell-truncate">
                        <span
                          title={
                            Array.isArray(subAdmin.assignedCompanies)
                              ? subAdmin.assignedCompanies.join(', ')
                              : subAdmin.assignedCompanies || '-'
                          }
                        >
                          {Array.isArray(subAdmin.assignedCompanies)
                            ? subAdmin.assignedCompanies.join(', ')
                            : subAdmin.assignedCompanies || '-'}
                        </span>
                      </TableCell>
                      <TableCell className="table-cell-truncate">
                        <span
                          title={
                            Array.isArray(subAdmin.assignedFeatures)
                              ? subAdmin.assignedFeatures.join(', ')
                              : subAdmin.assignedFeatures || '-'
                          }
                        >
                          {Array.isArray(subAdmin.assignedFeatures)
                            ? subAdmin.assignedFeatures.join(', ')
                            : subAdmin.assignedFeatures || '-'}
                        </span>
                      </TableCell>
                      <TableCell>
                        <div>{subAdmin.IsActive ? 'Active' : 'Inactive'}</div>
                      </TableCell>
                      <TableCell>
                        <div>{subAdmin.IsVerified ? 'Yes' : 'No'}</div>
                      </TableCell>
                      <TableCell className="d-flex space-between align-center">
                        <DeleteIcon
                          onClick={() => {
                            setDeleteModal(true);
                            setClickedData({
                              id: subAdmin.Id,
                              name:
                                subAdmin.FirstName + ' ' + subAdmin.LastName,
                            });
                          }}
                          className="ml-10 cursor"
                        />
                      </TableCell>
                    </TableRow>
                  )
                )
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={11}
                    align="center"
                    className="loadingSection"
                  >
                    No Records Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onClose={onCloseDeleteModal}
          metaData={`"${clickedData.name}"`}
          deleteFunction={deleteUser}
        />
      )}
    </>
  );
};

export default SubAdmins;
